import React, { useMemo } from "react";
import MainDropDown from "../../../dropDown/MainDropDown";
import RadioButton from "../../../radioButton/SquareRadioButton";
import MainInput from "../../../input";

import "../index.scss";

const defaultInterfaceOptions = [
  { label: "ACU", value: 0, isDisabled: true },
]

const DefaultPortOptions = {
  "0": [
    { label: "Wiegand port 1", value: 1, isDisabled: false },
    { label: "Wiegand port 2", value: 2, isDisabled: false },
  ],
  "GENERIC": [{
    label: "Internal", value: 1, isDisabled: false
  }],
  "AIR-R": [
    { label: "Internal", value: 1, isDisabled: false },
    { label: "External", value: 2, isDisabled: false },
  ],
  "AIR-CR": [
    { label: "Internal", value: 1, isDisabled: false },
    { label: "External", value: 2, isDisabled: false },
  ]
}

const DefaultDirectionOptions = [
  { label: "Entry", value: 0, isDisabled: false },
  { label: "Exit", value: 1, isDisabled: false },
]
const DefaultReaderTypeOptions = [
  { label: "RFID", value: 0, isDisabled: false },
  { label: "Keypad", value: 1, isDisabled: false },
  { label: "RFID + Keypad", value: 2, isDisabled: false },
]
const DefaultWiegandTypeOptions = [
  { label: "Auto", value: 0, isDisabled: false },
  { label: "Wiegand 4 (kaypad)", value: 1, isDisabled: false },
  { label: "Wiegand 8 (kaypad)", value: 2, isDisabled: false },
  { label: "Wiegand 26 (kaypad)", value: 3, isDisabled: false },
]

const ReadersType = ({
  interfaceType = 0, ACUModel ,
  selectOptions, name, port,readerType, reverse_byte_order,
  enable_crc, directionOptions = DefaultDirectionOptions,
  direction, enable_buzzer, source, component_source,
  setSelectedPorts, wiegandTypeOptions = DefaultWiegandTypeOptions,
  selectedPorts, readerTypeOptions = DefaultReaderTypeOptions, wiegandType = "0"
}) => {
  const componentSourceOptions = useMemo(() => {
    return source.readers.length ? source.readers : defaultInterfaceOptions;
  }, [source])

  const portOptions = useMemo(() => {
    const data = [];
    const Key= ACUModel === "AIR-CR" ? "AIR-CR" : component_source
    for (const property of DefaultPortOptions[Key]) {
      data.push({
        ...property,
        isDisabled: selectedPorts["readers"][component_source] ? !!selectedPorts["readers"][component_source][property.value] : false,
      });
    }
    return data.length ? data : DefaultPortOptions[Key];
  }, [selectedPorts,component_source]);

  return <div className="rfid-container">
    <div className="single-dropdown-container">
      <span>Component Source</span>
      <MainDropDown
        options={componentSourceOptions}
        selectedOption={component_source}
        placeholder="Component Source"
        onSelect={(option) => { selectOptions("component_source", option) }} />
    </div>

    <div className={"group-dropdown-container flex-item"}>
      <div className="drop-down-section" >
        <span>Port</span>
        <MainDropDown
          options={portOptions}
          selectedOption={port}
          placeholder="port"
          onSelect={(option) => {

                setSelectedPorts((prev) => {
                let data = {
                  ...prev,
                  ["readers"]: {
                    ...prev["readers"],
                    [component_source]: {
                      ...prev["readers"][component_source],
                      [option.value]: true,
                    }
                  },
                }
                delete data["readers"][component_source][port]
                return data;
              });
            selectOptions("port", option.value)
          }} />
      </div>
      <div className="drop-down-section">
        <span>Reader Type</span>
        <MainDropDown
          options={readerTypeOptions}
          selectedOption={readerType}
          placeholder="Reader Type"
          onSelect={(option) => {
            selectOptions("readerType", option.value)
            if (option.value == "0" || option.value == "2" ) { 
              selectOptions("wiegandType", 0)
            }
          }} />
      </div>
    </div>

    <div className={" flex-item"}  >
      <div className={"rfid-group-container flex-item"} >
        <div className="drop-down-section">
          <span>Wiegand type</span>
          <MainDropDown options={wiegandTypeOptions}
            className={"rfid-select"}
            placeholder="Choose an option"
            selectedOption={wiegandType}
            disabled={readerType == "0" || readerType == "2"}
            onSelect={(option) => { selectOptions("wiegandType", option.value) }} />
        </div>
        <div className="drop-down-section">
          <span>Direction</span>
          <MainDropDown options={directionOptions}
            placeholder="Choose an option"
            selectedOption={direction}
            onSelect={(option) => { selectOptions("direction", option.value) }} />
        </div>
      </div>

      <div className="rfid-radio-container">

        <RadioButton label="Revers byte order"
          onChange={(value) => {
            return selectOptions("reverse_byte_order", !reverse_byte_order)
          }}
          isSelected={reverse_byte_order} />
        <RadioButton
          className={"rfid-radio"}
          label="Enable CRC"
          onChange={(value) => {
            selectOptions("enable_crc", !enable_crc)
          }}
          isSelected={enable_crc} />
        <RadioButton
          className={"rfid-radio"}
          label="Enable buzzer"
          onChange={(value) => {
            selectOptions("enable_buzzer", !enable_buzzer)
          }}
          isSelected={enable_buzzer} />
      </div>


    </div >
    {/* <div style={{
      marginTop: "16px",
      marginBottom: "16px",
      borderBottom: "2px solid #10163a ",
      width: "100%",
      fontWeight: "500"
    }} />
    <div className={"group-dropdown-container flex-item"}>
      <div className="drop-down-section" >
        <span>This Access Point Exits the Zone below</span>
        <MainDropDown
          options={readerTypeOptions}
          selectedOption={port}
          placeholder="Reader Type"
          onSelect={(option) => {
            selectOptions("readerType", option.value)
          }} />
      </div>
      <div className="drop-down-section">
        <span>This Access Point Enters the Zone below</span>
        <MainDropDown
          options={readerTypeOptions}
          selectedOption={port}
          placeholder="Reader Type"
          onSelect={(option) => {
            selectOptions("readerType", option.value)
          }} />
      </div>
    </div> */}
  </div >;
}

export default ReadersType;